import { useQuery } from '@apollo/client';
import {
  Avatar,
  Badge,
  Table,
  Group,
  Text,
  TextInput,
  ActionIcon,
  Anchor,
  ScrollArea,
  Button,
  Title,
  Tooltip,
} from '@mantine/core';
import { Link } from 'react-router-dom';
import { IconEdit, IconSearch } from '@tabler/icons-react';
import { Client } from '@generated/graphql';
import { GET_CLIENTS } from '@queries/clients';
import LoadingData from '@components/graphql-loading-data';
import GraphqlError from '@components/graphql-error';

const statusColors: Record<string, string> = {
  current: 'green',
  archived: 'cyan',
  flagged: 'red',
};
interface RowProps {
  clients: Client[] | undefined;
}

function Rows({ clients }: RowProps) {
  if (clients) {
    const rows = clients.map((item) => (
      <Table.Tr key={item.id}>
        <Table.Td>
          <Anchor component={Link} to={`/clients/${item.id}`} underline="never">
            <Group>
              <Avatar size={30} src={item.avatar} radius={30} />
              {item.firstName} {item.lastName}
            </Group>
          </Anchor>
        </Table.Td>
        <Table.Td>
          <Badge color={statusColors[item.status.toLowerCase()]} variant="light">
            {item.status}
          </Badge>
        </Table.Td>
        <Table.Td>
          <Anchor component="button" size="sm">
            {item.email}
          </Anchor>
        </Table.Td>
        <Table.Td>
          <Text fz="sm" c="dimmed">
            {item.phone}
          </Text>
        </Table.Td>
        <Table.Td>
          <Group gap={10} justify="flex-end">
            <Tooltip label="Edit" withArrow>
              <ActionIcon variant="transparent">
                <IconEdit size="1.25rem" stroke={2} />
              </ActionIcon>
            </Tooltip>
          </Group>
        </Table.Td>
      </Table.Tr>
    ));
    return rows;
  }
}

// function ClientsTable({ data }: UsersTableProps) {
function ClientsTable() {
  const { loading, error, data } = useQuery(GET_CLIENTS);
  if (loading) return <LoadingData />;
  if (error) return <GraphqlError error={error} />;

  return (
    <>
      <Title order={2} pb={20}>
        CLIENTS
      </Title>

      <Group justify="space-between" pt={25} pb={35}>
        <TextInput w={300} leftSection={<IconSearch />} placeholder="Client Search" />
        <Button component={Link} to="/clients/new">
          + NEW CLIENT
        </Button>
      </Group>
      {/* TODO {data && <TableFilterSort data={data.allClients} title={titles} statusColors={statusColors} />} */}
      <ScrollArea>
        <Table verticalSpacing="md">
          <Table.Thead>
            <Table.Tr>
              <Table.Th>Client</Table.Th>
              <Table.Th>Status</Table.Th>
              <Table.Th>Email</Table.Th>
              <Table.Th>Phone</Table.Th>
              <Table.Th>&nbsp;</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            <Rows clients={data?.allClients} />
          </Table.Tbody>
        </Table>
      </ScrollArea>
    </>
  );
}

export default ClientsTable;
